import _classCallCheck from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/classCallCheck";

/**
 * 当前文件请求接口头地址
 */
export var urlDesignFaceTeachActivity = '/api/XOrg/BookMaterial/';
/**
 * 获取活动列表
 */

export var urlGetFaceTeachActivityList = urlDesignFaceTeachActivity + 'GetFaceTeachActivityList';
/**
 * 添加面授活动
 */

export var urlAddFaceTeachActivity = urlDesignFaceTeachActivity + 'AddFaceTeachActivity';
/**
 * 删除面授活动
 */

export var urlDeleteFaceTeachActivity = urlDesignFaceTeachActivity + 'DeleteFaceTeachActivity';
export var urlStartActivity = urlDesignFaceTeachActivity + 'StartFaceTeachActivity';
export var urlEndActivity = urlDesignFaceTeachActivity + 'EndFaceTeachActivity';
export var urlRestartActivity = urlDesignFaceTeachActivity + 'RestartFaceTeachActivity';
export var urlEditFaceTeachActivity = urlDesignFaceTeachActivity + 'EditFaceTeachActivity';
export var urlAddSource = urlDesignFaceTeachActivity + 'AddSource';
export var urlDeleteSource = urlDesignFaceTeachActivity + 'DeleteSource';
export var urlnotSignedStu = urlDesignFaceTeachActivity + 'notSignedStu';
export var urlRemoveStartFaceTeachActivity = urlDesignFaceTeachActivity + 'RemoveStartFaceTeachActivity';
export var urlgetSignStatic = urlDesignFaceTeachActivity + 'getSignStatic';
export var urlgetStudentSigned = urlDesignFaceTeachActivity + 'getStudentSigned';
/**
 * 获取资源列表
 */

export var urlGetSourceList = urlDesignFaceTeachActivity + 'GetSourceList';
import http from 'lib//http';
/**
 * 获取活动列表结果集
 */

export var FaceTeachActivityList = function FaceTeachActivityList() {
  _classCallCheck(this, FaceTeachActivityList);
};
/**
 * 获取活动列表
 * @param courseId 课程Id
 * @param classId 班级Id
 * @param signName 活动名称
 * @param page 页码
 */

export function GetFaceTeachActivityList(faceId, classState, activityName, activityType, page) {
  return http.post(urlGetFaceTeachActivityList, {
    faceId: faceId,
    classState: classState,
    activityName: activityName,
    activityType: activityType,
    page: page
  });
}
/**
 * 添加面授活动
 * @param courseId 课程Id
 * @param classId 班级Id
 * @param faceId 面授Id
 * @param signName 活动名称
 */

export function AddFaceTeachActivity(courseId, classId, faceId, faceTeachState, activityName, activityContent, voteType, dataJson, activityType, ActivityRemake, questionType, paperId, docJson, CreateIn, signType, RandNum, allowQuestionNum, EndDate, StartDate, AllowVoteNum) {
  return http.post(urlAddFaceTeachActivity, {
    courseId: courseId,
    classId: classId,
    faceId: faceId,
    faceTeachState: faceTeachState,
    activityName: activityName,
    activityContent: activityContent,
    voteType: voteType,
    dataJson: dataJson,
    activityType: activityType,
    ActivityRemake: ActivityRemake,
    questionType: questionType,
    paperId: paperId,
    docJson: docJson,
    CreateIn: CreateIn,
    signType: signType,
    RandNum: RandNum,
    allowQuestionNum: allowQuestionNum,
    EndDate: EndDate,
    StartDate: StartDate,
    AllowVoteNum: AllowVoteNum
  });
}
/*
*Excel导入面授活动
*/

export var urlbatchAddFaceTeachActivity = urlDesignFaceTeachActivity + 'BatchAddFaceTeachActivity';
export function BatchAddFaceTeachActivity(Ids, classId, faceId, faceTeachState, activityType, createIn) {
  return http.post(urlbatchAddFaceTeachActivity, {
    Ids: Ids,
    classId: classId,
    faceId: faceId,
    faceTeachState: faceTeachState,
    activityType: activityType,
    createIn: createIn
  });
}
export var urlGetClassAllStudent = urlDesignFaceTeachActivity + 'getClassAllStudent';
export var GetClassAllStudent = function GetClassAllStudent() {
  _classCallCheck(this, GetClassAllStudent);
};
/**
 * 获取班级成员信息
 */

export function getClassAllStudent(classId, faceId) {
  return http.post(urlGetClassAllStudent, {
    classId: classId,
    faceId: faceId
  });
}
export var urlupdateSignState = urlDesignFaceTeachActivity + 'updateSignState';
/**
 * 更新签到状态
 */

export function updateSignState(studentId, activityId, signState) {
  return http.post(urlupdateSignState, {
    studentId: studentId,
    activityId: activityId,
    signState: signState
  });
}
export var urlshowSignedStuCount = urlDesignFaceTeachActivity + 'showSignedStuCount';
export var ShowSignedStuCount = function ShowSignedStuCount() {
  _classCallCheck(this, ShowSignedStuCount);
};
/**
 * 获取签到学生数量
 */

export function showSignedStuCount(activityId) {
  return http.post(urlshowSignedStuCount, {
    activityId: activityId
  });
}
/**
 * 删除面授活动
 * @param Ids 面授活动Id
 */

export function DeleteFaceTeachActivity(Ids) {
  return http.post(urlDeleteFaceTeachActivity, {
    Ids: Ids
  });
} // 开始活动

export function StartFaceTeachActivity(Id) {
  return http.post(urlStartActivity, {
    Id: Id
  });
} // //停止活动

export function EndFaceTeachActivity(Id) {
  return http.post(urlEndActivity, {
    Id: Id
  });
} // //重启活动

export function RestartActivity(Id) {
  return http.post(urlRestartActivity, {
    Id: Id
  });
}
/**
 * 修改面授投票
 * @param faceId 面授投票Id
 * @param voteName 面授投票名称
 * @param voteContent 面授投票内容
 * @param voteType 面授投票类型
 * @param dataJson 面授投票选项json
 */

export function EditFaceTeachActivity(activityId, activityName, activityContent, voteType, dataJson, paperId, docJson, StartDate, EndDate, AllowVoteNum) {
  return http.post(urlEditFaceTeachActivity, {
    activityId: activityId,
    activityName: activityName,
    activityContent: activityContent,
    voteType: voteType,
    dataJson: dataJson,
    paperId: paperId,
    docJson: docJson,
    StartDate: StartDate,
    EndDate: EndDate,
    AllowVoteNum: AllowVoteNum
  });
} //添加资源

export function AddSource(ids, faceId, classId, courseId, faceTeachState, activityType, createIn) {
  return http.post(urlAddSource, {
    ids: ids,
    faceId: faceId,
    classId: classId,
    courseId: courseId,
    faceTeachState: faceTeachState,
    activityType: activityType,
    createIn: createIn
  });
} //删除资源

export function DeleteSource(activtyId, faceId, classId, courseId) {
  return http.post(urlDeleteSource, {
    activtyId: activtyId,
    faceId: faceId,
    classId: classId,
    courseId: courseId
  });
}
export var FaceTeachName = function FaceTeachName() {
  _classCallCheck(this, FaceTeachName);
};
export var urlFaceTeachName = urlDesignFaceTeachActivity + 'FaceTeachName'; //获取授课名称

export function GetFaceTeachName(faceId) {
  return http.post(urlFaceTeachName, {
    faceId: faceId
  });
}
export var StatisticalActivities = function StatisticalActivities() {
  _classCallCheck(this, StatisticalActivities);
};
export var urlStatisticalActivities = urlDesignFaceTeachActivity + 'StatisticalActivities'; // 获取授课活动过程

export function GetStatisticalActivities(classId, faceId) {
  return http.post(urlStatisticalActivities, {
    classId: classId,
    faceId: faceId
  });
}
export var urlStatisticalAllActivities = urlDesignFaceTeachActivity + 'StatisticalAllActivities'; // 获取全部授课活动过程

export function GetStatisticalAllActivities(classId, faceId) {
  return http.post(urlStatisticalAllActivities, {
    classId: classId,
    faceId: faceId
  });
}
export var urlSubmitFaceTeachFeedBack = urlDesignFaceTeachActivity + 'SubmitFaceTeachFeedBack';
export function SubmitFaceTeachFeedBack(faceId, courseId, classId, Summary, Abnormal, Remark) {
  return http.post(urlSubmitFaceTeachFeedBack, {
    faceId: faceId,
    courseId: courseId,
    classId: classId,
    Summary: Summary,
    Abnormal: Abnormal,
    Remark: Remark
  });
}
export var urlFaceTeachSummary = urlDesignFaceTeachActivity + 'FaceTeachSummary';
export var FaceTeachSummary = function FaceTeachSummary() {
  _classCallCheck(this, FaceTeachSummary);
};
export function FaceTeachSummaryList(faceId, seachStuName, seachStuNum) {
  return http.post(urlFaceTeachSummary, {
    faceId: faceId,
    seachStuName: seachStuName,
    seachStuNum: seachStuNum
  });
}
export var urlFaceTeachEvaluate = urlDesignFaceTeachActivity + 'FaceTeachEvaluate';
export var FaceTeachEvuluate = function FaceTeachEvuluate() {
  _classCallCheck(this, FaceTeachEvuluate);
};
export function FaceTeachEvuluateList(faceId, seachStuName, seachStuNum) {
  return http.post(urlFaceTeachEvaluate, {
    faceId: faceId,
    seachStuName: seachStuName,
    seachStuNum: seachStuNum
  });
}
export var urlDoScore = urlDesignFaceTeachActivity + 'doScore';
export function DoScore(ids, score) {
  return http.post(urlDoScore, {
    ids: ids,
    score: score
  });
}
export var urlFaceTeachPerformance = urlDesignFaceTeachActivity + 'FaceTeachPerformance';
export var FaceTeachPerformance = function FaceTeachPerformance() {
  _classCallCheck(this, FaceTeachPerformance);
};
export function FaceTeachPerformanceList(faceId, seachStuName, seachStuNum) {
  return http.post(urlFaceTeachPerformance, {
    faceId: faceId,
    seachStuName: seachStuName,
    seachStuNum: seachStuNum
  });
}
export var urldoScorePerformance = urlDesignFaceTeachActivity + 'doScorePerformance';
export function doScorePerformance(ids, score) {
  return http.post(urldoScorePerformance, {
    ids: ids,
    score: score
  });
}
export var getSignName = function getSignName() {
  _classCallCheck(this, getSignName);
};
export var urlgetSignName = urlDesignFaceTeachActivity + 'getSignName';
export function GetSignName(activityId) {
  return http.post(urlgetSignName, {
    activityId: activityId
  });
}
export var urlupdateSignName = urlDesignFaceTeachActivity + 'UpdateSignName';
export function UpdateSignName(activityId, signName) {
  return http.post(urlupdateSignName, {
    activityId: activityId,
    signName: signName
  });
}
export var urlDeleteSigned = urlDesignFaceTeachActivity + 'DeleteSigned';
export function DeleteSigned(activityId) {
  return http.post(urlDeleteSigned, {
    activityId: activityId
  });
}
export var urlgetOnlinePaperList = urlDesignFaceTeachActivity + 'getOnlinePaperList';
export function getOnlinePaperList(courseId, classId, faceId, page, pageSize) {
  return http.post(urlgetOnlinePaperList, {
    courseId: courseId,
    classId: classId,
    faceId: faceId,
    page: page,
    pageSize: pageSize
  });
} //未参与总结、评教学生统计请求配置

export var urlAbsentStu = '/api/XOrg/FaceTeachActivity/AbsentStu';
export function AbsentStu(faceId, ActitvityType) {
  return http.post(urlAbsentStu, {
    faceId: faceId,
    ActitvityType: ActitvityType
  });
}
/*--------------------------------------------获取测验列表----------------------------------------------------------------- */

export var urlGetPaperList = urlDesignFaceTeachActivity + 'getPaperList'; // 获取测验列表

export function GetPaperList(courseId, paperType, page, paperName, pageSize) {
  return http.get(urlGetPaperList, {
    params: {
      paperType: paperType,
      courseId: courseId,
      page: page,
      paperName: paperName,
      pageSize: pageSize
    }
  });
}
export var urlCourseAnalysis = urlDesignFaceTeachActivity + 'CourseAnalysis';
export function getCourseAnalysis(classId) {
  return http.post(urlCourseAnalysis, {
    classId: classId
  });
}
export var urlActivitylist = urlDesignFaceTeachActivity + 'Activitylist';
export function getActivitylist(classId, ActivityType) {
  return http.post(urlActivitylist, {
    classId: classId,
    ActivityType: ActivityType
  });
}
export var urlgetClassAllStuInfo = urlDesignFaceTeachActivity + 'getClassAllStuInfo';
export var getClassAllStuInfo = function getClassAllStuInfo() {
  _classCallCheck(this, getClassAllStuInfo);
};
export function GetClassAllStuInfo(classId, activityId, displayNamePiny) {
  return http.post(urlgetClassAllStuInfo, {
    classId: classId,
    activityId: activityId,
    displayNamePiny: displayNamePiny
  });
}
export var urlgetClassAllStuInfoByTraditionSign = urlDesignFaceTeachActivity + 'getClassAllStuInfoByTraditionSign';
export var IgetClassAllStuInfoByTraditionSign = function IgetClassAllStuInfoByTraditionSign() {
  _classCallCheck(this, IgetClassAllStuInfoByTraditionSign);
};
export function getClassAllStuInfoByTraditionSign(classId, activityId, displayNamePiny) {
  return http.post(urlgetClassAllStuInfoByTraditionSign, {
    classId: classId,
    activityId: activityId,
    displayNamePiny: displayNamePiny
  });
}
export var notSignedStu = function notSignedStu() {
  _classCallCheck(this, notSignedStu);
};
export function NotSignedStu(activityId) {
  return http.post(urlnotSignedStu, {
    activityId: activityId
  });
}
export function RemoveStartFaceTeachActivity(activityId) {
  return http.post(urlRemoveStartFaceTeachActivity, {
    activityId: activityId
  });
}
/*------------------------------------------------------------------------------------------------------------------------- */

export var SignStatic = function SignStatic() {
  _classCallCheck(this, SignStatic);
};
export function getSignStatic(faceId, studentId) {
  return http.post(urlgetSignStatic, {
    faceId: faceId,
    studentId: studentId
  });
}
export var IgetStudentSigned = function IgetStudentSigned() {
  _classCallCheck(this, IgetStudentSigned);
};
export function getStudentSigned(activityId) {
  return http.post(urlgetStudentSigned, {
    activityId: activityId
  });
} //添加资源到目录

export var urlsavecourseprocesscellDoc = "/api/XOrg/CourseSectionIndex/saveCourseProcessCellDoc";
export var IgetsaveCourseProcessCell = function IgetsaveCourseProcessCell() {
  _classCallCheck(this, IgetsaveCourseProcessCell);
};
export function saveCourseProcessCellDoc(courseId, topicId, parentId, maxSortOrder, docIds) {
  return http.post(urlsavecourseprocesscellDoc, {
    courseId: courseId,
    topicId: topicId,
    docIds: docIds,
    parentId: parentId,
    maxSortOrder: maxSortOrder
  });
}